const S = (fontFamily, fontSize, fontWeight, color, extra = {}) => ({
  fontFamily,
  fontSize,
  fontWeight,
  color,
  lineHeight: extra.lineHeight ?? 1.2,
  letterSpacing: extra.letterSpacing ?? 0,
  textAlign: extra.textAlign ?? 'center',
  textTransform: extra.textTransform ?? 'none',
  textShadow: extra.textShadow ?? null,
  stroke: extra.stroke ?? null,
  strokeWidth: extra.strokeWidth ?? 0,
  backgroundColor: extra.backgroundColor ?? null,
  backgroundOpacity: extra.backgroundOpacity ?? 1,
  padding: extra.padding ?? [0, 0, 0, 0],
  borderRadius: extra.borderRadius ?? 0,
});

export const TEXT_TEMPLATES = [
  // ── 1. Bold Promo Stack ───────────────────────────────────
  {
    id: 'tpl-01',
    name: 'Bold Promo Stack',
    category: 'Marketing',
    fonts: ['Bebas Neue', 'Montserrat'],
    previewStyle: { background: '#111', padding: '12px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 },
    previewContent: [
      { text: 'HOT DEAL', style: { fontFamily: 'Montserrat', fontSize: 9, fontWeight: 700, color: '#f59e0b', letterSpacing: 4, textTransform: 'uppercase' } },
      { text: 'BIG SALE', style: { fontFamily: 'Bebas Neue', fontSize: 28, fontWeight: 400, color: '#fff', lineHeight: 1, letterSpacing: 2 } },
      { text: 'UP TO 50% OFF', style: { fontFamily: 'Montserrat', fontSize: 8, fontWeight: 600, color: '#f59e0b', letterSpacing: 2, textTransform: 'uppercase' } },
    ],
    layers: [
      { data: { type: 'text', content: 'HOT DEAL', style: S('Montserrat', 18, '800', '#f59e0b', { letterSpacing: 6, textTransform: 'uppercase', lineHeight: 1 }) }, transform: { x: 5, y: 26, width: 90, height: 8, zIndex: 1 } },
      { data: { type: 'text', content: 'BIG SUMMER\nSALE', style: S('Bebas Neue', 88, '400', '#ffffff', { letterSpacing: 3, lineHeight: 0.95 }) }, transform: { x: 5, y: 32, width: 90, height: 30, zIndex: 2 } },
      { data: { type: 'text', content: 'UP TO 50% OFF SELECTED ITEMS', style: S('Montserrat', 14, '600', '#f59e0b', { letterSpacing: 2, textTransform: 'uppercase', lineHeight: 1 }) }, transform: { x: 5, y: 63, width: 90, height: 6, zIndex: 3 } },
      { data: { type: 'text', content: 'Limited time offer', style: S('Montserrat', 13, '400', 'rgba(255,255,255,0.6)', { lineHeight: 1 }) }, transform: { x: 5, y: 70, width: 90, height: 5, zIndex: 4 } },
    ],
  },

  // ── 2. Elegant Serif Editorial ────────────────────────────
  {
    id: 'tpl-02',
    name: 'Elegant Editorial',
    category: 'Editorial',
    fonts: ['Playfair Display', 'Inter'],
    previewStyle: { background: '#faf7f2', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4 },
    previewContent: [
      { text: 'WELLNESS', style: { fontFamily: 'Inter', fontSize: 7, fontWeight: 400, color: '#999', letterSpacing: 4, textTransform: 'uppercase' } },
      { text: 'Healthy Habits\nfor a Better Life', style: { fontFamily: 'Playfair Display', fontSize: 13, fontWeight: 700, color: '#1a1a1a', lineHeight: 1.2, textAlign: 'center' } },
      { text: '— By Sarah Mitchell', style: { fontFamily: 'Inter', fontSize: 7, fontWeight: 300, color: '#999' } },
    ],
    layers: [
      { data: { type: 'text', content: 'WELLNESS', style: S('Inter', 14, '400', '#999999', { letterSpacing: 6, textTransform: 'uppercase', lineHeight: 1 }) }, transform: { x: 5, y: 28, width: 90, height: 6, zIndex: 1 } },
      { data: { type: 'text', content: 'Healthy Habits\nfor a Better Life', style: S('Playfair Display', 52, '700', '#1a1a1a', { lineHeight: 1.15, letterSpacing: -0.5 }) }, transform: { x: 5, y: 34, width: 90, height: 30, zIndex: 2 } },
      { data: { type: 'text', content: '— By Sarah Mitchell', style: S('Inter', 16, '300', '#999999', { lineHeight: 1 }) }, transform: { x: 5, y: 66, width: 90, height: 6, zIndex: 3 } },
    ],
  },

  // ── 3. Script + Minimal ───────────────────────────────────
  {
    id: 'tpl-03',
    name: 'Script Elegant',
    category: 'Beauty',
    fonts: ['Great Vibes', 'Montserrat'],
    previewStyle: { background: '#fff', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 },
    previewContent: [
      { text: 'Eyes Makeup', style: { fontFamily: 'Great Vibes', fontSize: 20, fontWeight: 400, color: '#b08d70' } },
      { text: 'TUTORIAL FOR BEGINNERS', style: { fontFamily: 'Montserrat', fontSize: 6, fontWeight: 600, color: '#888', letterSpacing: 2, textTransform: 'uppercase' } },
    ],
    layers: [
      { data: { type: 'text', content: 'Eyes Makeup', style: S('Great Vibes', 72, '400', '#b08d70', { lineHeight: 1.1 }) }, transform: { x: 5, y: 35, width: 90, height: 22, zIndex: 1 } },
      { data: { type: 'text', content: 'QUICK TUTORIAL FOR BEGINNERS', style: S('Montserrat', 13, '600', '#888888', { letterSpacing: 3, textTransform: 'uppercase', lineHeight: 1 }) }, transform: { x: 5, y: 58, width: 90, height: 6, zIndex: 2 } },
    ],
  },

  // ── 4. Black Friday Blast ─────────────────────────────────
  {
    id: 'tpl-04',
    name: 'Black Friday Blast',
    category: 'Retail',
    fonts: ['Bebas Neue', 'Oswald'],
    previewStyle: { background: '#000', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 },
    previewContent: [
      { text: 'BLACK FRIDAY', style: { fontFamily: 'Bebas Neue', fontSize: 16, fontWeight: 400, color: '#fff', letterSpacing: 3, lineHeight: 1 } },
      { text: '80%', style: { fontFamily: 'Bebas Neue', fontSize: 40, fontWeight: 400, color: '#ef4444', lineHeight: 0.9 } },
      { text: 'OFF EVERYTHING', style: { fontFamily: 'Oswald', fontSize: 9, fontWeight: 500, color: '#fff', letterSpacing: 3, textTransform: 'uppercase' } },
    ],
    layers: [
      { data: { type: 'text', content: 'BLACK FRIDAY', style: S('Bebas Neue', 52, '400', '#ffffff', { letterSpacing: 6, lineHeight: 1 }) }, transform: { x: 5, y: 22, width: 90, height: 12, zIndex: 1 } },
      { data: { type: 'text', content: '80%', style: S('Bebas Neue', 160, '400', '#ef4444', { lineHeight: 0.9, letterSpacing: -2 }) }, transform: { x: 5, y: 30, width: 90, height: 38, zIndex: 2 } },
      { data: { type: 'text', content: 'OFF EVERYTHING', style: S('Oswald', 28, '500', '#ffffff', { letterSpacing: 6, textTransform: 'uppercase', lineHeight: 1 }) }, transform: { x: 5, y: 69, width: 90, height: 8, zIndex: 3 } },
      { data: { type: 'text', content: 'Shop Now →', style: S('Oswald', 16, '300', 'rgba(255,255,255,0.6)', { letterSpacing: 2, lineHeight: 1 }) }, transform: { x: 5, y: 78, width: 90, height: 5, zIndex: 4 } },
    ],
  },

  // ── 5. Luxury Minimal ─────────────────────────────────────
  {
    id: 'tpl-05',
    name: 'Luxury Minimal',
    category: 'Luxury',
    fonts: ['Cormorant Garamond', 'Poppins'],
    previewStyle: { background: '#f5f0e8', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 5 },
    previewContent: [
      { text: '— Collection —', style: { fontFamily: 'Poppins', fontSize: 6, fontWeight: 300, color: '#9a8872', letterSpacing: 3 } },
      { text: 'Maison\nNoble', style: { fontFamily: 'Cormorant Garamond', fontSize: 22, fontWeight: 500, color: '#2a2218', lineHeight: 1.1, textAlign: 'center', fontStyle: 'italic' } },
      { text: '✦', style: { fontFamily: 'Poppins', fontSize: 10, fontWeight: 300, color: '#9a8872' } },
    ],
    layers: [
      { data: { type: 'text', content: '— Exclusive Collection —', style: S('Poppins', 14, '300', '#9a8872', { letterSpacing: 4, textTransform: 'uppercase', lineHeight: 1 }) }, transform: { x: 5, y: 28, width: 90, height: 6, zIndex: 1 } },
      { data: { type: 'text', content: 'Maison\nNoble', style: { ...S('Cormorant Garamond', 76, '500', '#2a2218', { lineHeight: 1.05, letterSpacing: 1 }), fontStyle: 'italic' } }, transform: { x: 5, y: 33, width: 90, height: 28, zIndex: 2 } },
      { data: { type: 'text', content: '✦ ✦ ✦', style: S('Poppins', 14, '300', '#9a8872', { letterSpacing: 8, lineHeight: 1 }) }, transform: { x: 5, y: 62, width: 90, height: 6, zIndex: 3 } },
      { data: { type: 'text', content: 'EST. 2024', style: S('Poppins', 12, '300', '#9a8872', { letterSpacing: 6, textTransform: 'uppercase', lineHeight: 1 }) }, transform: { x: 5, y: 69, width: 90, height: 5, zIndex: 4 } },
    ],
  },

  // ── 6. Magazine Article ───────────────────────────────────
  {
    id: 'tpl-06',
    name: 'Magazine Header',
    category: 'Editorial',
    fonts: ['Abril Fatface', 'Lato'],
    previewStyle: { background: '#fff', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', gap: 3 },
    previewContent: [
      { text: 'CULTURE', style: { fontFamily: 'Lato', fontSize: 6, fontWeight: 900, color: '#ef4444', letterSpacing: 3, textTransform: 'uppercase', borderBottom: '1px solid #ef4444', paddingBottom: 2 } },
      { text: "Humanity's\nNew Best\nFriend", style: { fontFamily: 'Abril Fatface', fontSize: 16, fontWeight: 400, color: '#111', lineHeight: 1.1, textAlign: 'left' } },
      { text: 'BY JAMES PARK  ·  5 MIN READ', style: { fontFamily: 'Lato', fontSize: 5, fontWeight: 400, color: '#999', letterSpacing: 1 } },
    ],
    layers: [
      { data: { type: 'text', content: 'CULTURE', style: S('Lato', 16, '900', '#ef4444', { letterSpacing: 5, textTransform: 'uppercase', textAlign: 'left', lineHeight: 1 }) }, transform: { x: 6, y: 24, width: 88, height: 6, zIndex: 1 } },
      { data: { type: 'text', content: "Humanity's\nNew Best\nFriend", style: S('Abril Fatface', 58, '400', '#111111', { lineHeight: 1.05, textAlign: 'left' }) }, transform: { x: 6, y: 30, width: 88, height: 38, zIndex: 2 } },
      { data: { type: 'text', content: 'BY JAMES PARK  ·  5 MIN READ', style: S('Lato', 13, '400', '#999999', { letterSpacing: 2, textAlign: 'left', lineHeight: 1 }) }, transform: { x: 6, y: 69, width: 88, height: 5, zIndex: 3 } },
    ],
  },

  // ── 7. Outlined Hero ─────────────────────────────────────
  {
    id: 'tpl-07',
    name: 'Outlined Hero',
    category: 'Bold',
    fonts: ['Bebas Neue'],
    previewStyle: { background: '#1a1a2e', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 },
    previewContent: [
      { text: 'DARE TO', style: { fontFamily: 'Bebas Neue', fontSize: 22, fontWeight: 400, color: 'transparent', WebkitTextStroke: '1px #fff', letterSpacing: 4, lineHeight: 1 } },
      { text: 'BE BOLD', style: { fontFamily: 'Bebas Neue', fontSize: 22, fontWeight: 400, color: 'var(--brand-primary)', letterSpacing: 4, lineHeight: 1 } },
    ],
    layers: [
      { data: { type: 'text', content: 'DARE TO', style: S('Bebas Neue', 90, '400', 'transparent', { letterSpacing: 6, lineHeight: 1, stroke: '#ffffff', strokeWidth: 2 }) }, transform: { x: 5, y: 33, width: 90, height: 22, zIndex: 1 } },
      { data: { type: 'text', content: 'BE BOLD', style: S('Bebas Neue', 90, '400', 'var(--brand-primary)', { letterSpacing: 6, lineHeight: 1 }) }, transform: { x: 5, y: 53, width: 90, height: 22, zIndex: 2 } },
    ],
  },

  // ── 8. Food Menu Style ────────────────────────────────────
  {
    id: 'tpl-08',
    name: 'Menu Style',
    category: 'Food',
    fonts: ['Playfair Display', 'Lora'],
    previewStyle: { background: '#1a1205', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3 },
    previewContent: [
      { text: 'BEST SELLERS', style: { fontFamily: 'Playfair Display', fontSize: 9, fontWeight: 700, color: '#d4a843', letterSpacing: 3, textTransform: 'uppercase', textAlign: 'center' } },
      { text: '─────────', style: { fontFamily: 'Lora', fontSize: 8, fontWeight: 400, color: '#d4a843' } },
      { text: 'Truffle Pasta ......... $28', style: { fontFamily: 'Lora', fontSize: 7, fontWeight: 400, color: '#f5e6c8', textAlign: 'left' } },
      { text: 'Wagyu Steak ........ $64', style: { fontFamily: 'Lora', fontSize: 7, fontWeight: 400, color: '#f5e6c8', textAlign: 'left' } },
      { text: 'Lobster Bisque ..... $32', style: { fontFamily: 'Lora', fontSize: 7, fontWeight: 400, color: '#f5e6c8', textAlign: 'left' } },
    ],
    layers: [
      { data: { type: 'text', content: 'BEST SELLERS', style: S('Playfair Display', 32, '700', '#d4a843', { letterSpacing: 5, textTransform: 'uppercase', lineHeight: 1 }) }, transform: { x: 5, y: 22, width: 90, height: 8, zIndex: 1 } },
      { data: { type: 'text', content: '──────────────────', style: S('Lora', 16, '400', '#d4a843', { lineHeight: 1 }) }, transform: { x: 5, y: 30, width: 90, height: 4, zIndex: 2 } },
      { data: { type: 'text', content: 'Truffle Pasta .................. $28\nWagyu Steak ............... $64\nLobster Bisque .............. $32\nChocolate Soufflé ......... $18', style: S('Lora', 20, '400', '#f5e6c8', { lineHeight: 1.7, textAlign: 'left', letterSpacing: 0.3 }) }, transform: { x: 8, y: 35, width: 84, height: 40, zIndex: 3 } },
      { data: { type: 'text', content: '──────────────────', style: S('Lora', 16, '400', '#d4a843', { lineHeight: 1 }) }, transform: { x: 5, y: 75, width: 90, height: 4, zIndex: 4 } },
    ],
  },

  // ── 9. Event Invitation ───────────────────────────────────
  {
    id: 'tpl-09',
    name: 'Formal Invitation',
    category: 'Event',
    fonts: ['Cinzel', 'Cormorant Garamond'],
    previewStyle: { background: '#0d0a00', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3 },
    previewContent: [
      { text: 'You Are Cordially', style: { fontFamily: 'Cormorant Garamond', fontSize: 9, fontWeight: 400, color: '#c9a84c', fontStyle: 'italic', letterSpacing: 1 } },
      { text: 'INVITED', style: { fontFamily: 'Cinzel', fontSize: 18, fontWeight: 700, color: '#f5e6b8', letterSpacing: 6 } },
      { text: 'to join us at', style: { fontFamily: 'Cormorant Garamond', fontSize: 8, fontWeight: 400, color: '#c9a84c', fontStyle: 'italic' } },
      { text: 'THE GRAND\nGALA 2025', style: { fontFamily: 'Cinzel', fontSize: 11, fontWeight: 600, color: '#fff', letterSpacing: 3, lineHeight: 1.3, textAlign: 'center' } },
    ],
    layers: [
      { data: { type: 'text', content: 'You Are Cordially', style: { ...S('Cormorant Garamond', 24, '400', '#c9a84c', { letterSpacing: 1, lineHeight: 1 }), fontStyle: 'italic' } }, transform: { x: 5, y: 22, width: 90, height: 7, zIndex: 1 } },
      { data: { type: 'text', content: 'INVITED', style: S('Cinzel', 56, '700', '#f5e6b8', { letterSpacing: 10, lineHeight: 1 }) }, transform: { x: 5, y: 29, width: 90, height: 14, zIndex: 2 } },
      { data: { type: 'text', content: 'to join us at', style: { ...S('Cormorant Garamond', 22, '400', '#c9a84c', { letterSpacing: 1, lineHeight: 1 }), fontStyle: 'italic' } }, transform: { x: 5, y: 43, width: 90, height: 7, zIndex: 3 } },
      { data: { type: 'text', content: 'THE GRAND\nGALA 2025', style: S('Cinzel', 44, '600', '#ffffff', { letterSpacing: 4, lineHeight: 1.2 }) }, transform: { x: 5, y: 50, width: 90, height: 20, zIndex: 4 } },
      { data: { type: 'text', content: 'Saturday, June 14th  ·  8:00 PM', style: S('Cormorant Garamond', 20, '400', '#c9a84c', { letterSpacing: 1, lineHeight: 1 }) }, transform: { x: 5, y: 71, width: 90, height: 6, zIndex: 5 } },
    ],
  },

  // ── 10. Fashion Minimal ───────────────────────────────────
  {
    id: 'tpl-10',
    name: 'Fashion Minimal',
    category: 'Fashion',
    fonts: ['Raleway', 'Libre Baskerville'],
    previewStyle: { background: '#fff', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4 },
    previewContent: [
      { text: 'N E W  S E A S O N', style: { fontFamily: 'Raleway', fontSize: 6, fontWeight: 200, color: '#aaa', letterSpacing: 4 } },
      { text: 'VOGUE', style: { fontFamily: 'Libre Baskerville', fontSize: 30, fontWeight: 700, color: '#111', letterSpacing: 8, lineHeight: 1 } },
      { text: 'COLLECTION', style: { fontFamily: 'Raleway', fontSize: 8, fontWeight: 300, color: '#555', letterSpacing: 5 } },
      { text: '— SS 2025 —', style: { fontFamily: 'Raleway', fontSize: 6, fontWeight: 300, color: '#ccc', letterSpacing: 3 } },
    ],
    layers: [
      { data: { type: 'text', content: 'N E W  S E A S O N', style: S('Raleway', 16, '200', '#aaaaaa', { letterSpacing: 5, textTransform: 'uppercase', lineHeight: 1 }) }, transform: { x: 5, y: 26, width: 90, height: 6, zIndex: 1 } },
      { data: { type: 'text', content: 'VOGUE', style: S('Libre Baskerville', 88, '700', '#111111', { letterSpacing: 10, lineHeight: 1 }) }, transform: { x: 5, y: 32, width: 90, height: 22, zIndex: 2 } },
      { data: { type: 'text', content: 'COLLECTION', style: S('Raleway', 24, '300', '#555555', { letterSpacing: 8, textTransform: 'uppercase', lineHeight: 1 }) }, transform: { x: 5, y: 55, width: 90, height: 8, zIndex: 3 } },
      { data: { type: 'text', content: '— SS 2025 —', style: S('Raleway', 16, '300', '#cccccc', { letterSpacing: 4, lineHeight: 1 }) }, transform: { x: 5, y: 65, width: 90, height: 6, zIndex: 4 } },
    ],
  },

  // ── 11. Free Delivery Promo ───────────────────────────────
  {
    id: 'tpl-11',
    name: 'Free Delivery Badge',
    category: 'Marketing',
    fonts: ['Anton', 'Poppins'],
    previewStyle: { background: '#16a34a', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3 },
    previewContent: [
      { text: '🚚', style: { fontSize: 20, lineHeight: 1 } },
      { text: 'FREE', style: { fontFamily: 'Anton', fontSize: 30, fontWeight: 400, color: '#fff', letterSpacing: 4, lineHeight: 1 } },
      { text: 'DELIVERY', style: { fontFamily: 'Anton', fontSize: 18, fontWeight: 400, color: 'rgba(255,255,255,0.7)', letterSpacing: 3, lineHeight: 1 } },
      { text: 'on orders over $50', style: { fontFamily: 'Poppins', fontSize: 6, fontWeight: 400, color: 'rgba(255,255,255,0.8)', letterSpacing: 0.5 } },
    ],
    layers: [
      { data: { type: 'text', content: '🚚', style: S('Poppins', 56, '400', '#ffffff', { lineHeight: 1 }) }, transform: { x: 5, y: 22, width: 90, height: 14, zIndex: 1 } },
      { data: { type: 'text', content: 'FREE', style: S('Anton', 96, '400', '#ffffff', { letterSpacing: 8, lineHeight: 1 }) }, transform: { x: 5, y: 35, width: 90, height: 24, zIndex: 2 } },
      { data: { type: 'text', content: 'DELIVERY', style: S('Anton', 56, '400', 'rgba(255,255,255,0.75)', { letterSpacing: 5, lineHeight: 1 }) }, transform: { x: 5, y: 58, width: 90, height: 14, zIndex: 3 } },
      { data: { type: 'text', content: 'on orders over $50', style: S('Poppins', 18, '400', 'rgba(255,255,255,0.85)', { letterSpacing: 0.5, lineHeight: 1 }) }, transform: { x: 5, y: 73, width: 90, height: 6, zIndex: 4 } },
    ],
  },

  // ── 12. Corporate Clean ───────────────────────────────────
  {
    id: 'tpl-12',
    name: 'Corporate Clean',
    category: 'Corporate',
    fonts: ['IBM Plex Sans', 'Poppins'],
    previewStyle: { background: '#f8faff', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', gap: 3 },
    previewContent: [
      { text: 'Q4 REPORT', style: { fontFamily: 'IBM Plex Sans', fontSize: 6, fontWeight: 600, color: '#3b82f6', letterSpacing: 3, textTransform: 'uppercase', borderLeft: '2px solid #3b82f6', paddingLeft: 4 } },
      { text: 'Revenue\nGrew 40%', style: { fontFamily: 'IBM Plex Sans', fontSize: 16, fontWeight: 700, color: '#0f172a', lineHeight: 1.1, textAlign: 'left' } },
      { text: 'Year over year growth across\nall product categories.', style: { fontFamily: 'Poppins', fontSize: 5.5, fontWeight: 300, color: '#64748b', lineHeight: 1.5, textAlign: 'left' } },
    ],
    layers: [
      { data: { type: 'text', content: 'Q4 2025 ANNUAL REPORT', style: S('IBM Plex Sans', 16, '600', '#3b82f6', { letterSpacing: 4, textTransform: 'uppercase', textAlign: 'left', lineHeight: 1 }) }, transform: { x: 6, y: 24, width: 88, height: 6, zIndex: 1 } },
      { data: { type: 'text', content: 'Revenue\nGrew 40%', style: S('IBM Plex Sans', 72, '700', '#0f172a', { lineHeight: 1.05, textAlign: 'left', letterSpacing: -1 }) }, transform: { x: 6, y: 30, width: 88, height: 36, zIndex: 2 } },
      { data: { type: 'text', content: 'Year over year growth across all\nproduct categories in 2025.', style: S('Poppins', 18, '300', '#64748b', { lineHeight: 1.6, textAlign: 'left' }) }, transform: { x: 6, y: 68, width: 88, height: 14, zIndex: 3 } },
    ],
  },

  // ── 13. Youth / Social Bold ───────────────────────────────
  {
    id: 'tpl-13',
    name: 'Youth Social',
    category: 'Bold',
    fonts: ['Fredoka One', 'Poppins'],
    previewStyle: { background: 'linear-gradient(135deg, #f59e0b, #ef4444)', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 },
    previewContent: [
      { text: 'GOING', style: { fontFamily: 'Fredoka One', fontSize: 20, fontWeight: 400, color: '#fff', lineHeight: 1, letterSpacing: 2 } },
      { text: 'VIRAL', style: { fontFamily: 'Fredoka One', fontSize: 32, fontWeight: 400, color: '#fff9c4', lineHeight: 0.9, letterSpacing: 1 } },
      { text: '🔥 Share this now', style: { fontFamily: 'Poppins', fontSize: 6.5, fontWeight: 500, color: '#fff' } },
    ],
    layers: [
      { data: { type: 'text', content: 'GOING', style: S('Fredoka One', 72, '400', '#ffffff', { letterSpacing: 4, lineHeight: 1 }) }, transform: { x: 5, y: 30, width: 90, height: 18, zIndex: 1 } },
      { data: { type: 'text', content: 'VIRAL 🔥', style: S('Fredoka One', 96, '400', '#fff9c4', { lineHeight: 0.9, letterSpacing: 1 }) }, transform: { x: 5, y: 46, width: 90, height: 24, zIndex: 2 } },
      { data: { type: 'text', content: 'Share this with your friends!', style: S('Poppins', 18, '500', '#ffffff', { lineHeight: 1 }) }, transform: { x: 5, y: 72, width: 90, height: 6, zIndex: 3 } },
    ],
  },

  // ── 14. Minimal Quote ─────────────────────────────────────
  {
    id: 'tpl-14',
    name: 'Minimal Quote',
    category: 'Minimal',
    fonts: ['Lora', 'Poppins'],
    previewStyle: { background: '#fff', padding: '14px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 5 },
    previewContent: [
      { text: '❝', style: { fontFamily: 'Lora', fontSize: 28, fontWeight: 700, color: '#e5e7eb', lineHeight: 1 } },
      { text: 'The only way to do great work is to love what you do.', style: { fontFamily: 'Lora', fontSize: 9, fontWeight: 400, color: '#374151', lineHeight: 1.6, textAlign: 'center', fontStyle: 'italic' } },
      { text: '— Steve Jobs', style: { fontFamily: 'Poppins', fontSize: 6, fontWeight: 500, color: '#9ca3af', letterSpacing: 1 } },
    ],
    layers: [
      { data: { type: 'text', content: '❝', style: S('Lora', 80, '700', '#e5e7eb', { lineHeight: 1 }) }, transform: { x: 5, y: 20, width: 90, height: 18, zIndex: 1 } },
      { data: { type: 'text', content: 'The only way to do great work is to love what you do.', style: { ...S('Lora', 28, '400', '#374151', { lineHeight: 1.65 }), fontStyle: 'italic' } }, transform: { x: 8, y: 30, width: 84, height: 38, zIndex: 2 } },
      { data: { type: 'text', content: '— Steve Jobs', style: S('Poppins', 16, '500', '#9ca3af', { letterSpacing: 2, lineHeight: 1 }) }, transform: { x: 5, y: 70, width: 90, height: 6, zIndex: 3 } },
    ],
  },

  // ── 15. Limited Offer ─────────────────────────────────────
  {
    id: 'tpl-15',
    name: 'Limited Offer',
    category: 'Retail',
    fonts: ['Oswald', 'Roboto Condensed'],
    previewStyle: { background: '#18181b', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 },
    previewContent: [
      { text: '⚡ LIMITED OFFER ⚡', style: { fontFamily: 'Roboto Condensed', fontSize: 6.5, fontWeight: 400, color: '#fbbf24', letterSpacing: 2 } },
      { text: 'ONLY', style: { fontFamily: 'Oswald', fontSize: 14, fontWeight: 300, color: '#fff', letterSpacing: 6 } },
      { text: '$19', style: { fontFamily: 'Oswald', fontSize: 40, fontWeight: 700, color: '#fbbf24', lineHeight: 0.9 } },
      { text: 'per month', style: { fontFamily: 'Roboto Condensed', fontSize: 7, fontWeight: 300, color: 'rgba(255,255,255,0.6)', letterSpacing: 1 } },
    ],
    layers: [
      { data: { type: 'text', content: '⚡ LIMITED OFFER ⚡', style: S('Roboto Condensed', 18, '400', '#fbbf24', { letterSpacing: 3, lineHeight: 1 }) }, transform: { x: 5, y: 22, width: 90, height: 7, zIndex: 1 } },
      { data: { type: 'text', content: 'ONLY', style: S('Oswald', 36, '300', '#ffffff', { letterSpacing: 10, lineHeight: 1 }) }, transform: { x: 5, y: 30, width: 90, height: 10, zIndex: 2 } },
      { data: { type: 'text', content: '$19', style: S('Oswald', 148, '700', '#fbbf24', { lineHeight: 0.85, letterSpacing: -2 }) }, transform: { x: 5, y: 38, width: 90, height: 38, zIndex: 3 } },
      { data: { type: 'text', content: 'per month  ·  cancel anytime', style: S('Roboto Condensed', 16, '300', 'rgba(255,255,255,0.55)', { letterSpacing: 1.5, lineHeight: 1 }) }, transform: { x: 5, y: 77, width: 90, height: 5, zIndex: 4 } },
    ],
  },

  // ── 16. Action / Adventure ────────────────────────────────
  {
    id: 'tpl-16',
    name: 'Action Hero',
    category: 'Bold',
    fonts: ['Bebas Neue', 'Oswald'],
    previewStyle: { background: '#0f0f0f', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1 },
    previewContent: [
      { text: 'SUMMER 2025', style: { fontFamily: 'Oswald', fontSize: 6, fontWeight: 200, color: '#ef4444', letterSpacing: 4, textTransform: 'uppercase' } },
      { text: 'ACTION', style: { fontFamily: 'Bebas Neue', fontSize: 36, fontWeight: 400, color: '#fff', letterSpacing: 8, lineHeight: 1, textShadow: '4px 4px 0px #ef4444' } },
    ],
    layers: [
      { data: { type: 'text', content: 'SUMMER 2025', style: S('Oswald', 18, '200', '#ef4444', { letterSpacing: 6, textTransform: 'uppercase', lineHeight: 1 }) }, transform: { x: 5, y: 26, width: 90, height: 7, zIndex: 1 } },
      { data: { type: 'text', content: 'ACTION', style: S('Bebas Neue', 130, '400', '#ffffff', { letterSpacing: 10, lineHeight: 0.95, textShadow: '6px 6px 0px #ef4444' }) }, transform: { x: 5, y: 33, width: 90, height: 34, zIndex: 2 } },
      { data: { type: 'text', content: 'STARTS NOW', style: S('Bebas Neue', 52, '400', '#ef4444', { letterSpacing: 5, lineHeight: 1 }) }, transform: { x: 5, y: 65, width: 90, height: 14, zIndex: 3 } },
    ],
  },

  // ── 17. Feminine Script ───────────────────────────────────
  {
    id: 'tpl-17',
    name: 'Feminine Script',
    category: 'Beauty',
    fonts: ['Dancing Script', 'Raleway'],
    previewStyle: { background: '#fff0f5', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3 },
    previewContent: [
      { text: 'Self Love', style: { fontFamily: 'Dancing Script', fontSize: 22, fontWeight: 700, color: '#d63384', lineHeight: 1 } },
      { text: '✿ ✿ ✿', style: { fontFamily: 'Raleway', fontSize: 8, fontWeight: 300, color: '#f9a8d4', letterSpacing: 4 } },
      { text: 'BEAUTY TIPS & TRICKS', style: { fontFamily: 'Raleway', fontSize: 5.5, fontWeight: 400, color: '#d63384', letterSpacing: 3, textTransform: 'uppercase' } },
    ],
    layers: [
      { data: { type: 'text', content: 'Self Love', style: S('Dancing Script', 88, '700', '#d63384', { lineHeight: 1 }) }, transform: { x: 5, y: 30, width: 90, height: 24, zIndex: 1 } },
      { data: { type: 'text', content: '✿  ✿  ✿', style: S('Raleway', 20, '300', '#f9a8d4', { letterSpacing: 8, lineHeight: 1 }) }, transform: { x: 5, y: 55, width: 90, height: 7, zIndex: 2 } },
      { data: { type: 'text', content: 'BEAUTY TIPS & TRICKS', style: S('Raleway', 14, '400', '#d63384', { letterSpacing: 4, textTransform: 'uppercase', lineHeight: 1 }) }, transform: { x: 5, y: 63, width: 90, height: 6, zIndex: 3 } },
    ],
  },

  // ── 18. Stacked Repeat ────────────────────────────────────
  {
    id: 'tpl-18',
    name: 'Stacked Marquee',
    category: 'Modern',
    fonts: ['Bebas Neue'],
    previewStyle: { background: '#0a0a0a', padding: '8px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 0, overflow: 'hidden' },
    previewContent: [
      { text: 'TRENDING ★ TRENDING ★', style: { fontFamily: 'Bebas Neue', fontSize: 11, fontWeight: 400, color: 'rgba(255,255,255,0.12)', letterSpacing: 3, lineHeight: 1, whiteSpace: 'nowrap' } },
      { text: 'TRENDING ★ TRENDING ★', style: { fontFamily: 'Bebas Neue', fontSize: 11, fontWeight: 400, color: 'rgba(255,255,255,0.25)', letterSpacing: 3, lineHeight: 1, whiteSpace: 'nowrap' } },
      { text: 'TRENDING', style: { fontFamily: 'Bebas Neue', fontSize: 22, fontWeight: 400, color: '#ffffff', letterSpacing: 6, lineHeight: 1 } },
      { text: 'TRENDING ★ TRENDING ★', style: { fontFamily: 'Bebas Neue', fontSize: 11, fontWeight: 400, color: 'rgba(255,255,255,0.25)', letterSpacing: 3, lineHeight: 1, whiteSpace: 'nowrap' } },
      { text: 'TRENDING ★ TRENDING ★', style: { fontFamily: 'Bebas Neue', fontSize: 11, fontWeight: 400, color: 'rgba(255,255,255,0.12)', letterSpacing: 3, lineHeight: 1, whiteSpace: 'nowrap' } },
    ],
    layers: [
      { data: { type: 'text', content: 'TRENDING ★ TRENDING ★ TRENDING ★', style: S('Bebas Neue', 28, '400', 'rgba(255,255,255,0.1)', { letterSpacing: 4, lineHeight: 1 }) }, transform: { x: -5, y: 26, width: 110, height: 8, zIndex: 1 } },
      { data: { type: 'text', content: 'TRENDING ★ TRENDING ★ TRENDING ★', style: S('Bebas Neue', 32, '400', 'rgba(255,255,255,0.18)', { letterSpacing: 4, lineHeight: 1 }) }, transform: { x: -5, y: 34, width: 110, height: 9, zIndex: 2 } },
      { data: { type: 'text', content: 'TRENDING', style: S('Bebas Neue', 100, '400', '#ffffff', { letterSpacing: 8, lineHeight: 1 }) }, transform: { x: 5, y: 40, width: 90, height: 24, zIndex: 3 } },
      { data: { type: 'text', content: 'TRENDING ★ TRENDING ★ TRENDING ★', style: S('Bebas Neue', 32, '400', 'rgba(255,255,255,0.18)', { letterSpacing: 4, lineHeight: 1 }) }, transform: { x: -5, y: 64, width: 110, height: 9, zIndex: 4 } },
      { data: { type: 'text', content: 'TRENDING ★ TRENDING ★ TRENDING ★', style: S('Bebas Neue', 28, '400', 'rgba(255,255,255,0.1)', { letterSpacing: 4, lineHeight: 1 }) }, transform: { x: -5, y: 73, width: 110, height: 8, zIndex: 5 } },
    ],
  },

  // ── 19. News Ticker Style ─────────────────────────────────
  {
    id: 'tpl-19',
    name: 'Breaking News',
    category: 'Editorial',
    fonts: ['Oswald', 'IBM Plex Sans'],
    previewStyle: { background: '#fff', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', gap: 2 },
    previewContent: [
      { text: 'BREAKING', style: { fontFamily: 'Oswald', fontSize: 8, fontWeight: 700, color: '#fff', background: '#dc2626', padding: '1px 5px', letterSpacing: 1, textTransform: 'uppercase' } },
      { text: 'LEARN THE\nLANGUAGE', style: { fontFamily: 'Oswald', fontSize: 20, fontWeight: 600, color: '#111', lineHeight: 1, textAlign: 'left' } },
      { text: 'The future of communication is changing', style: { fontFamily: 'IBM Plex Sans', fontSize: 5.5, fontWeight: 300, color: '#666', textAlign: 'left' } },
    ],
    layers: [
      { data: { type: 'text', content: 'BREAKING', style: S('Oswald', 18, '700', '#ffffff', { letterSpacing: 2, textTransform: 'uppercase', textAlign: 'left', lineHeight: 1, backgroundColor: '#dc2626', backgroundOpacity: 1, padding: [4, 10, 4, 10], borderRadius: 2 }) }, transform: { x: 6, y: 22, width: 40, height: 7, zIndex: 1 } },
      { data: { type: 'text', content: 'LEARN THE\nLANGUAGE', style: S('Oswald', 68, '600', '#111111', { lineHeight: 1, textAlign: 'left', letterSpacing: 1 }) }, transform: { x: 6, y: 30, width: 88, height: 36, zIndex: 2 } },
      { data: { type: 'text', content: 'The future of communication is changing fast', style: S('IBM Plex Sans', 16, '300', '#666666', { textAlign: 'left', lineHeight: 1.5 }) }, transform: { x: 6, y: 68, width: 88, height: 8, zIndex: 3 } },
    ],
  },

  // ── 20. Poster Bold ───────────────────────────────────────
  {
    id: 'tpl-20',
    name: 'Vintage Poster',
    category: 'Marketing',
    fonts: ['Playfair Display', 'Raleway'],
    previewStyle: { background: '#f5e6c8', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 },
    previewContent: [
      { text: 'THE GREATEST', style: { fontFamily: 'Raleway', fontSize: 6, fontWeight: 800, color: '#7c2d12', letterSpacing: 4, textTransform: 'uppercase' } },
      { text: 'Show\non Earth', style: { fontFamily: 'Playfair Display', fontSize: 20, fontWeight: 800, color: '#1a0a00', lineHeight: 1.1, textAlign: 'center' } },
      { text: '★★★★★', style: { fontSize: 9, color: '#b45309' } },
      { text: 'FRIDAY · 8 PM · MAIN STAGE', style: { fontFamily: 'Raleway', fontSize: 5, fontWeight: 700, color: '#7c2d12', letterSpacing: 2 } },
    ],
    layers: [
      { data: { type: 'text', content: 'THE GREATEST', style: S('Raleway', 20, '800', '#7c2d12', { letterSpacing: 6, textTransform: 'uppercase', lineHeight: 1 }) }, transform: { x: 5, y: 20, width: 90, height: 7, zIndex: 1 } },
      { data: { type: 'text', content: 'Show\non Earth', style: S('Playfair Display', 72, '800', '#1a0a00', { lineHeight: 1.05 }) }, transform: { x: 5, y: 27, width: 90, height: 36, zIndex: 2 } },
      { data: { type: 'text', content: '★ ★ ★ ★ ★', style: S('Raleway', 20, '400', '#b45309', { letterSpacing: 4, lineHeight: 1 }) }, transform: { x: 5, y: 63, width: 90, height: 7, zIndex: 3 } },
      { data: { type: 'text', content: 'FRIDAY  ·  8 PM  ·  MAIN STAGE', style: S('Raleway', 14, '700', '#7c2d12', { letterSpacing: 3, textTransform: 'uppercase', lineHeight: 1 }) }, transform: { x: 5, y: 71, width: 90, height: 6, zIndex: 4 } },
    ],
  },

  // ── 21. Split Contrast ────────────────────────────────────
  {
    id: 'tpl-21',
    name: 'Split Contrast',
    category: 'Modern',
    fonts: ['Montserrat'],
    previewStyle: { background: '#fff', padding: 0, display: 'flex', flexDirection: 'column', alignItems: 'stretch', justifyContent: 'center', overflow: 'hidden' },
    previewContent: [
      { text: 'YOUR', style: { fontFamily: 'Montserrat', fontSize: 24, fontWeight: 900, color: '#fff', background: '#111', textAlign: 'center', padding: '6px 0', letterSpacing: 4, lineHeight: 1 } },
      { text: 'STORY', style: { fontFamily: 'Montserrat', fontSize: 24, fontWeight: 900, color: '#111', textAlign: 'center', padding: '6px 0', letterSpacing: 4, lineHeight: 1 } },
    ],
    layers: [
      { data: { type: 'shape', shape: 'rectangle', fill: '#111111', stroke: null, strokeWidth: 0, borderRadius: 0 }, transform: { x: 0, y: 0, width: 100, height: 50, zIndex: 1 } },
      { data: { type: 'text', content: 'YOUR', style: S('Montserrat', 88, '900', '#ffffff', { letterSpacing: 8, lineHeight: 1 }) }, transform: { x: 5, y: 22, width: 90, height: 24, zIndex: 2 } },
      { data: { type: 'text', content: 'STORY', style: S('Montserrat', 88, '900', '#111111', { letterSpacing: 8, lineHeight: 1 }) }, transform: { x: 5, y: 52, width: 90, height: 24, zIndex: 3 } },
    ],
  },

  // ── 22. Thin Luxury ───────────────────────────────────────
  {
    id: 'tpl-22',
    name: 'Ultra Thin Luxury',
    category: 'Luxury',
    fonts: ['Cormorant Garamond', 'Raleway'],
    previewStyle: { background: '#0a0705', padding: '12px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4 },
    previewContent: [
      { text: '- PRESTIGE -', style: { fontFamily: 'Raleway', fontSize: 5.5, fontWeight: 100, color: '#9a8060', letterSpacing: 5 } },
      { text: 'Atelier', style: { fontFamily: 'Cormorant Garamond', fontSize: 26, fontWeight: 300, color: '#e8d5b0', lineHeight: 1, fontStyle: 'italic' } },
      { text: 'NOIR', style: { fontFamily: 'Raleway', fontSize: 20, fontWeight: 100, color: '#e8d5b0', letterSpacing: 12, lineHeight: 1 } },
      { text: '────────────', style: { fontFamily: 'Raleway', fontSize: 5, fontWeight: 100, color: '#9a8060' } },
      { text: 'PARIS  ·  MILAN  ·  DUBAI', style: { fontFamily: 'Raleway', fontSize: 4.5, fontWeight: 300, color: '#9a8060', letterSpacing: 3 } },
    ],
    layers: [
      { data: { type: 'text', content: '—  PRESTIGE  —', style: S('Raleway', 14, '100', '#9a8060', { letterSpacing: 6, lineHeight: 1 }) }, transform: { x: 5, y: 26, width: 90, height: 5, zIndex: 1 } },
      { data: { type: 'text', content: 'Atelier', style: { ...S('Cormorant Garamond', 80, '300', '#e8d5b0', { lineHeight: 1 }), fontStyle: 'italic' } }, transform: { x: 5, y: 30, width: 90, height: 20, zIndex: 2 } },
      { data: { type: 'text', content: 'NOIR', style: S('Raleway', 64, '100', '#e8d5b0', { letterSpacing: 20, lineHeight: 1 }) }, transform: { x: 5, y: 51, width: 90, height: 16, zIndex: 3 } },
      { data: { type: 'text', content: '─────────────────────', style: S('Raleway', 12, '100', '#9a8060', { lineHeight: 1 }) }, transform: { x: 5, y: 68, width: 90, height: 4, zIndex: 4 } },
      { data: { type: 'text', content: 'PARIS  ·  MILAN  ·  DUBAI', style: S('Raleway', 13, '300', '#9a8060', { letterSpacing: 4, lineHeight: 1 }) }, transform: { x: 5, y: 73, width: 90, height: 5, zIndex: 5 } },
    ],
  },

  // ── 23. Gradient Text Effect ──────────────────────────────
  {
    id: 'tpl-23',
    name: 'Neon Glow',
    category: 'Modern',
    fonts: ['Bebas Neue'],
    previewStyle: { background: '#060612', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3 },
    previewContent: [
      { text: 'FUTURE', style: { fontFamily: 'Bebas Neue', fontSize: 30, fontWeight: 400, color: '#a78bfa', textShadow: '0 0 20px #7c3aed, 0 0 40px #4c1d95', letterSpacing: 6, lineHeight: 1 } },
      { text: 'IS NOW', style: { fontFamily: 'Bebas Neue', fontSize: 24, fontWeight: 400, color: '#67e8f9', textShadow: '0 0 20px #0891b2', letterSpacing: 4, lineHeight: 1 } },
    ],
    layers: [
      { data: { type: 'text', content: 'FUTURE', style: S('Bebas Neue', 110, '400', '#a78bfa', { letterSpacing: 8, lineHeight: 1, textShadow: '0 0 30px #7c3aed, 0 0 60px #4c1d95, 0 0 80px #2e1065' }) }, transform: { x: 5, y: 28, width: 90, height: 28, zIndex: 1 } },
      { data: { type: 'text', content: 'IS NOW', style: S('Bebas Neue', 88, '400', '#67e8f9', { letterSpacing: 6, lineHeight: 1, textShadow: '0 0 30px #0891b2, 0 0 60px #0e7490' }) }, transform: { x: 5, y: 55, width: 90, height: 22, zIndex: 2 } },
    ],
  },

  // ── 24. Spring Sale ───────────────────────────────────────
  {
    id: 'tpl-24',
    name: 'Spring Sale',
    category: 'Retail',
    fonts: ['Montserrat', 'Dancing Script'],
    previewStyle: { background: '#f0fdf4', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 },
    previewContent: [
      { text: 'Spring', style: { fontFamily: 'Dancing Script', fontSize: 22, fontWeight: 700, color: '#16a34a', lineHeight: 1 } },
      { text: 'SALE', style: { fontFamily: 'Montserrat', fontSize: 28, fontWeight: 900, color: '#166534', letterSpacing: 5, lineHeight: 1 } },
      { text: '20% OFF SITEWIDE', style: { fontFamily: 'Montserrat', fontSize: 6.5, fontWeight: 600, color: '#16a34a', letterSpacing: 2, background: '#dcfce7', padding: '2px 6px', borderRadius: 3 } },
    ],
    layers: [
      { data: { type: 'text', content: 'Spring', style: S('Dancing Script', 84, '700', '#16a34a', { lineHeight: 1 }) }, transform: { x: 5, y: 26, width: 90, height: 22, zIndex: 1 } },
      { data: { type: 'text', content: 'SALE', style: S('Montserrat', 100, '900', '#166534', { letterSpacing: 8, lineHeight: 1 }) }, transform: { x: 5, y: 46, width: 90, height: 26, zIndex: 2 } },
      { data: { type: 'text', content: '🌸 20% OFF SITEWIDE 🌸', style: S('Montserrat', 18, '600', '#16a34a', { letterSpacing: 2, lineHeight: 1 }) }, transform: { x: 5, y: 73, width: 90, height: 7, zIndex: 3 } },
    ],
  },

  // ── 25. Drop Shadow Display ───────────────────────────────
  {
    id: 'tpl-25',
    name: 'Hard Shadow',
    category: 'Bold',
    fonts: ['Anton'],
    previewStyle: { background: '#fff8e1', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 },
    previewContent: [
      { text: 'MAKE IT', style: { fontFamily: 'Anton', fontSize: 20, fontWeight: 400, color: '#fff', textShadow: '3px 3px 0 #111, 6px 6px 0 rgba(0,0,0,0.15)', letterSpacing: 3, lineHeight: 1, WebkitTextStroke: '1px #111' } },
      { text: 'HAPPEN', style: { fontFamily: 'Anton', fontSize: 20, fontWeight: 400, color: '#f59e0b', textShadow: '3px 3px 0 #111', letterSpacing: 3, lineHeight: 1 } },
    ],
    layers: [
      { data: { type: 'text', content: 'MAKE IT', style: S('Anton', 76, '400', '#ffffff', { letterSpacing: 6, lineHeight: 1, textShadow: '5px 5px 0 #1a1a1a, 10px 10px 0 rgba(0,0,0,0.1)', stroke: '#1a1a1a', strokeWidth: 1 }) }, transform: { x: 5, y: 30, width: 90, height: 22, zIndex: 1 } },
      { data: { type: 'text', content: 'HAPPEN', style: S('Anton', 76, '400', '#f59e0b', { letterSpacing: 6, lineHeight: 1, textShadow: '5px 5px 0 #1a1a1a' }) }, transform: { x: 5, y: 50, width: 90, height: 22, zIndex: 2 } },
    ],
  },

  // ── 26. Minimal Countdown ─────────────────────────────────
  {
    id: 'tpl-26',
    name: 'Countdown Timer',
    category: 'Marketing',
    fonts: ['IBM Plex Sans', 'Montserrat'],
    previewStyle: { background: 'var(--brand-900)', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3 },
    previewContent: [
      { text: 'HURRY! OFFER ENDS IN', style: { fontFamily: 'Montserrat', fontSize: 5, fontWeight: 600, color: 'var(--brand-300)', letterSpacing: 2 } },
      { text: '24:00:00', style: { fontFamily: 'IBM Plex Sans', fontSize: 26, fontWeight: 700, color: '#fff', letterSpacing: 4, lineHeight: 1 } },
      { text: 'HOURS  ·  MINUTES  ·  SECONDS', style: { fontFamily: 'Montserrat', fontSize: 4.5, fontWeight: 400, color: 'rgba(165,180,252,0.7)', letterSpacing: 2 } },
    ],
    layers: [
      { data: { type: 'text', content: 'HURRY! OFFER ENDS IN', style: S('Montserrat', 16, '600', 'var(--brand-300)', { letterSpacing: 3, lineHeight: 1 }) }, transform: { x: 5, y: 28, width: 90, height: 6, zIndex: 1 } },
      { data: { type: 'text', content: '24 : 00 : 00', style: S('IBM Plex Sans', 80, '700', '#ffffff', { letterSpacing: 4, lineHeight: 1 }) }, transform: { x: 5, y: 35, width: 90, height: 22, zIndex: 2 } },
      { data: { type: 'text', content: 'HRS          MIN          SEC', style: S('Montserrat', 13, '400', 'rgba(165,180,252,0.7)', { letterSpacing: 2, lineHeight: 1 }) }, transform: { x: 5, y: 58, width: 90, height: 5, zIndex: 3 } },
      { data: { type: 'text', content: '⚡  Grab yours before it\'s gone!', style: S('Montserrat', 18, '500', 'var(--brand-100)', { lineHeight: 1 }) }, transform: { x: 5, y: 68, width: 90, height: 6, zIndex: 4 } },
    ],
  },

  // ── 27. Wedding / Romance ─────────────────────────────────
  {
    id: 'tpl-27',
    name: 'Wedding Romance',
    category: 'Event',
    fonts: ['Cormorant Garamond', 'Great Vibes'],
    previewStyle: { background: '#fdfaf6', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 },
    previewContent: [
      { text: 'Sarah & James', style: { fontFamily: 'Great Vibes', fontSize: 18, fontWeight: 400, color: '#78594a' } },
      { text: 'ARE GETTING MARRIED', style: { fontFamily: 'Cormorant Garamond', fontSize: 6.5, fontWeight: 400, color: '#a08070', letterSpacing: 3, textTransform: 'uppercase' } },
      { text: '♡', style: { fontSize: 12, color: '#c4897b' } },
      { text: 'June 14, 2025', style: { fontFamily: 'Cormorant Garamond', fontSize: 8, fontWeight: 600, color: '#78594a' } },
    ],
    layers: [
      { data: { type: 'text', content: 'Sarah & James', style: S('Great Vibes', 68, '400', '#78594a', { lineHeight: 1 }) }, transform: { x: 5, y: 28, width: 90, height: 18, zIndex: 1 } },
      { data: { type: 'text', content: 'ARE GETTING MARRIED', style: S('Cormorant Garamond', 18, '400', '#a08070', { letterSpacing: 4, textTransform: 'uppercase', lineHeight: 1 }) }, transform: { x: 5, y: 47, width: 90, height: 7, zIndex: 2 } },
      { data: { type: 'text', content: '♡', style: S('Cormorant Garamond', 36, '400', '#c4897b', { lineHeight: 1 }) }, transform: { x: 5, y: 55, width: 90, height: 8, zIndex: 3 } },
      { data: { type: 'text', content: 'June 14, 2025', style: S('Cormorant Garamond', 24, '600', '#78594a', { letterSpacing: 2, lineHeight: 1 }) }, transform: { x: 5, y: 64, width: 90, height: 7, zIndex: 4 } },
      { data: { type: 'text', content: 'The Ritz-Carlton, Grand Ballroom', style: S('Cormorant Garamond', 18, '400', '#a08070', { lineHeight: 1, letterSpacing: 1 }) }, transform: { x: 5, y: 72, width: 90, height: 6, zIndex: 5 } },
    ],
  },

  // ── 28. Tech Startup ──────────────────────────────────────
  {
    id: 'tpl-28',
    name: 'Tech Startup',
    category: 'Corporate',
    fonts: ['Poppins', 'IBM Plex Sans'],
    previewStyle: { background: '#0f0f23', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', gap: 3 },
    previewContent: [
      { text: '🚀 LAUNCHING SOON', style: { fontFamily: 'IBM Plex Sans', fontSize: 5.5, fontWeight: 500, color: 'var(--brand-400)', letterSpacing: 2 } },
      { text: 'Build\nFaster.', style: { fontFamily: 'Poppins', fontSize: 22, fontWeight: 800, color: '#fff', lineHeight: 1.05, textAlign: 'left' } },
      { text: 'Ship\nSmarter.', style: { fontFamily: 'Poppins', fontSize: 22, fontWeight: 800, color: 'var(--brand-400)', lineHeight: 1.05, textAlign: 'left' } },
    ],
    layers: [
      { data: { type: 'text', content: '🚀 LAUNCHING SOON', style: S('IBM Plex Sans', 16, '500', 'var(--brand-400)', { letterSpacing: 3, textAlign: 'left', lineHeight: 1 }) }, transform: { x: 6, y: 22, width: 88, height: 6, zIndex: 1 } },
      { data: { type: 'text', content: 'Build\nFaster.', style: S('Poppins', 76, '800', '#ffffff', { lineHeight: 1, textAlign: 'left', letterSpacing: -1 }) }, transform: { x: 6, y: 28, width: 88, height: 34, zIndex: 2 } },
      { data: { type: 'text', content: 'Ship\nSmarter.', style: S('Poppins', 76, '800', 'var(--brand-400)', { lineHeight: 1, textAlign: 'left', letterSpacing: -1 }) }, transform: { x: 6, y: 58, width: 88, height: 34, zIndex: 3 } },
    ],
  },

  // ── 29. Retro Wave ────────────────────────────────────────
  {
    id: 'tpl-29',
    name: 'Retro Wave',
    category: 'Modern',
    fonts: ['Bebas Neue', 'Poppins'],
    previewStyle: { background: 'linear-gradient(180deg, #1a0040 0%, #6b21a8 50%, #f97316 100%)', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 },
    previewContent: [
      { text: '1 9 8 5', style: { fontFamily: 'Poppins', fontSize: 7, fontWeight: 200, color: '#f0abfc', letterSpacing: 6 } },
      { text: 'RETRO\nWAVE', style: { fontFamily: 'Bebas Neue', fontSize: 28, fontWeight: 400, color: '#fff', lineHeight: 0.9, letterSpacing: 4, textShadow: '0 0 20px #f97316' } },
      { text: 'SYNTHWAVE COLLECTION', style: { fontFamily: 'Poppins', fontSize: 5, fontWeight: 400, color: '#f9a8d4', letterSpacing: 2 } },
    ],
    layers: [
      { data: { type: 'text', content: '1  9  8  5', style: S('Poppins', 18, '200', '#f0abfc', { letterSpacing: 8, lineHeight: 1 }) }, transform: { x: 5, y: 23, width: 90, height: 7, zIndex: 1 } },
      { data: { type: 'text', content: 'RETRO\nWAVE', style: S('Bebas Neue', 100, '400', '#ffffff', { lineHeight: 0.9, letterSpacing: 6, textShadow: '0 0 30px #f97316, 0 0 60px #ea580c' }) }, transform: { x: 5, y: 30, width: 90, height: 36, zIndex: 2 } },
      { data: { type: 'text', content: 'SYNTHWAVE COLLECTION', style: S('Poppins', 14, '400', '#f9a8d4', { letterSpacing: 4, lineHeight: 1 }) }, transform: { x: 5, y: 67, width: 90, height: 6, zIndex: 3 } },
    ],
  },

  // ── 30. Motivational Stack ────────────────────────────────
  {
    id: 'tpl-30',
    name: 'Motivational Stack',
    category: 'Marketing',
    fonts: ['Montserrat', 'Poppins'],
    previewStyle: { background: '#fff', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1 },
    previewContent: [
      { text: 'YOU CAN', style: { fontFamily: 'Montserrat', fontSize: 15, fontWeight: 900, color: '#e5e7eb', letterSpacing: 2, lineHeight: 1 } },
      { text: 'DO IT', style: { fontFamily: 'Montserrat', fontSize: 28, fontWeight: 900, color: '#111', letterSpacing: 2, lineHeight: 1 } },
      { text: 'Start today. Not tomorrow.', style: { fontFamily: 'Poppins', fontSize: 6, fontWeight: 300, color: '#6b7280' } },
    ],
    layers: [
      { data: { type: 'text', content: 'YOU CAN', style: S('Montserrat', 68, '900', '#e5e7eb', { letterSpacing: 4, lineHeight: 1 }) }, transform: { x: 5, y: 28, width: 90, height: 18, zIndex: 1 } },
      { data: { type: 'text', content: 'DO IT', style: S('Montserrat', 100, '900', '#111111', { letterSpacing: 4, lineHeight: 1 }) }, transform: { x: 5, y: 43, width: 90, height: 26, zIndex: 2 } },
      { data: { type: 'text', content: 'Start today. Not tomorrow.', style: S('Poppins', 18, '300', '#6b7280', { lineHeight: 1 }) }, transform: { x: 5, y: 71, width: 90, height: 6, zIndex: 3 } },
    ],
  },

  // ── 31. Social Proof ──────────────────────────────────────
  {
    id: 'tpl-31',
    name: 'Social Proof',
    category: 'Marketing',
    fonts: ['Poppins', 'Montserrat'],
    previewStyle: { background: '#fffbeb', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3 },
    previewContent: [
      { text: '★★★★★', style: { fontSize: 12, color: '#f59e0b' } },
      { text: '"Changed my life\ncompletely!"', style: { fontFamily: 'Poppins', fontSize: 9, fontWeight: 600, color: '#1f2937', lineHeight: 1.4, textAlign: 'center', fontStyle: 'italic' } },
      { text: '— Emma R.  ·  Verified Buyer', style: { fontFamily: 'Montserrat', fontSize: 5.5, fontWeight: 500, color: '#9ca3af', letterSpacing: 1 } },
    ],
    layers: [
      { data: { type: 'text', content: '★ ★ ★ ★ ★', style: S('Poppins', 24, '400', '#f59e0b', { letterSpacing: 4, lineHeight: 1 }) }, transform: { x: 5, y: 24, width: 90, height: 8, zIndex: 1 } },
      { data: { type: 'text', content: '"Changed my life\ncompletely!"', style: { ...S('Poppins', 36, '600', '#1f2937', { lineHeight: 1.4 }), fontStyle: 'italic' } }, transform: { x: 8, y: 33, width: 84, height: 32, zIndex: 2 } },
      { data: { type: 'text', content: '— Emma R.  ·  Verified Buyer', style: S('Montserrat', 16, '500', '#9ca3af', { letterSpacing: 1.5, lineHeight: 1 }) }, transform: { x: 5, y: 67, width: 90, height: 6, zIndex: 3 } },
      { data: { type: 'text', content: '4.9/5 from 12,000+ reviews', style: S('Poppins', 14, '400', '#6b7280', { lineHeight: 1 }) }, transform: { x: 5, y: 75, width: 90, height: 5, zIndex: 4 } },
    ],
  },

  // ── 32. Minimal Dark ──────────────────────────────────────
  {
    id: 'tpl-32',
    name: 'Minimal Dark',
    category: 'Minimal',
    fonts: ['Raleway', 'Poppins'],
    previewStyle: { background: '#09090b', padding: '12px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4 },
    previewContent: [
      { text: '/', style: { fontFamily: 'Raleway', fontSize: 16, fontWeight: 100, color: '#3f3f46' } },
      { text: 'Less is\nMore', style: { fontFamily: 'Raleway', fontSize: 18, fontWeight: 200, color: '#fafafa', lineHeight: 1.2, textAlign: 'center', letterSpacing: 2 } },
      { text: '/', style: { fontFamily: 'Raleway', fontSize: 16, fontWeight: 100, color: '#3f3f46' } },
    ],
    layers: [
      { data: { type: 'text', content: '/', style: S('Raleway', 32, '100', '#3f3f46', { lineHeight: 1 }) }, transform: { x: 5, y: 28, width: 90, height: 8, zIndex: 1 } },
      { data: { type: 'text', content: 'Less is\nMore', style: S('Raleway', 76, '200', '#fafafa', { lineHeight: 1.15, letterSpacing: 3 }) }, transform: { x: 5, y: 33, width: 90, height: 36, zIndex: 2 } },
      { data: { type: 'text', content: '/', style: S('Raleway', 32, '100', '#3f3f46', { lineHeight: 1 }) }, transform: { x: 5, y: 70, width: 90, height: 8, zIndex: 3 } },
    ],
  },

  // ── 33. Grunge / Street ───────────────────────────────────
  {
    id: 'tpl-33',
    name: 'Street Grunge',
    category: 'Bold',
    fonts: ['Oswald', 'Bebas Neue'],
    previewStyle: { background: '#1c1917', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', gap: 0, overflow: 'hidden' },
    previewContent: [
      { text: 'STREET', style: { fontFamily: 'Bebas Neue', fontSize: 28, fontWeight: 400, color: '#fff', letterSpacing: 3, lineHeight: 1 } },
      { text: 'CULTURE', style: { fontFamily: 'Bebas Neue', fontSize: 28, fontWeight: 400, color: 'transparent', WebkitTextStroke: '1px #f5f5f4', letterSpacing: 3, lineHeight: 1 } },
      { text: '2025 ──────', style: { fontFamily: 'Oswald', fontSize: 7, fontWeight: 200, color: '#a8a29e', letterSpacing: 3 } },
    ],
    layers: [
      { data: { type: 'text', content: 'STREET', style: S('Bebas Neue', 110, '400', '#ffffff', { letterSpacing: 5, lineHeight: 1, textAlign: 'left' }) }, transform: { x: 5, y: 25, width: 90, height: 28, zIndex: 1 } },
      { data: { type: 'text', content: 'CULTURE', style: S('Bebas Neue', 92, '400', 'transparent', { letterSpacing: 3, lineHeight: 1, textAlign: 'left', stroke: '#f5f5f4', strokeWidth: 2 }) }, transform: { x: 5, y: 50, width: 90, height: 24, zIndex: 2 } },
      { data: { type: 'text', content: '2025  ────────────────', style: S('Oswald', 18, '200', '#a8a29e', { letterSpacing: 4, textAlign: 'left', lineHeight: 1 }) }, transform: { x: 5, y: 75, width: 90, height: 6, zIndex: 3 } },
    ],
  },

  // ── 34. Fitness / Gym ─────────────────────────────────────
  {
    id: 'tpl-34',
    name: 'Fitness Power',
    category: 'Bold',
    fonts: ['Roboto Condensed', 'Oswald'],
    previewStyle: { background: '#0a0a0a', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1 },
    previewContent: [
      { text: 'NO', style: { fontFamily: 'Roboto Condensed', fontSize: 26, fontWeight: 700, color: '#ef4444', letterSpacing: 6, lineHeight: 1 } },
      { text: 'PAIN', style: { fontFamily: 'Oswald', fontSize: 28, fontWeight: 700, color: '#fff', letterSpacing: 4, lineHeight: 1 } },
      { text: 'NO GAIN', style: { fontFamily: 'Oswald', fontSize: 20, fontWeight: 300, color: 'rgba(255,255,255,0.4)', letterSpacing: 6, lineHeight: 1 } },
    ],
    layers: [
      { data: { type: 'text', content: 'NO', style: S('Roboto Condensed', 100, '700', '#ef4444', { letterSpacing: 12, lineHeight: 1 }) }, transform: { x: 5, y: 22, width: 90, height: 25, zIndex: 1 } },
      { data: { type: 'text', content: 'PAIN', style: S('Oswald', 100, '700', '#ffffff', { letterSpacing: 6, lineHeight: 1 }) }, transform: { x: 5, y: 44, width: 90, height: 25, zIndex: 2 } },
      { data: { type: 'text', content: 'NO GAIN', style: S('Oswald', 44, '300', 'rgba(255,255,255,0.35)', { letterSpacing: 8, lineHeight: 1 }) }, transform: { x: 5, y: 70, width: 90, height: 12, zIndex: 3 } },
    ],
  },

  // ── 35. Bestseller Badge ──────────────────────────────────
  {
    id: 'tpl-35',
    name: 'Bestseller Badge',
    category: 'Retail',
    fonts: ['Playfair Display', 'Poppins'],
    previewStyle: { background: '#fef3c7', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 },
    previewContent: [
      { text: '# 1', style: { fontFamily: 'Playfair Display', fontSize: 28, fontWeight: 800, color: '#b45309', lineHeight: 1 } },
      { text: 'BESTSELLER', style: { fontFamily: 'Poppins', fontSize: 8, fontWeight: 800, color: '#92400e', letterSpacing: 4, textTransform: 'uppercase' } },
      { text: 'NEW YORK TIMES', style: { fontFamily: 'Poppins', fontSize: 5.5, fontWeight: 400, color: '#b45309', letterSpacing: 3 } },
    ],
    layers: [
      { data: { type: 'text', content: '#1', style: S('Playfair Display', 120, '800', '#b45309', { lineHeight: 1 }) }, transform: { x: 5, y: 24, width: 90, height: 32, zIndex: 1 } },
      { data: { type: 'text', content: 'BESTSELLER', style: S('Poppins', 28, '800', '#92400e', { letterSpacing: 6, textTransform: 'uppercase', lineHeight: 1 }) }, transform: { x: 5, y: 57, width: 90, height: 9, zIndex: 2 } },
      { data: { type: 'text', content: 'NEW YORK TIMES', style: S('Poppins', 16, '400', '#b45309', { letterSpacing: 4, lineHeight: 1 }) }, transform: { x: 5, y: 67, width: 90, height: 6, zIndex: 3 } },
    ],
  },

  // ── 36. Aesthetic OOTD ────────────────────────────────────
  {
    id: 'tpl-36',
    name: 'OOTD Aesthetic',
    category: 'Fashion',
    fonts: ['Montserrat', 'Dancing Script'],
    previewStyle: { background: '#f8f4f0', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3 },
    previewContent: [
      { text: 'outfit of\nthe day', style: { fontFamily: 'Dancing Script', fontSize: 16, fontWeight: 400, color: '#5c4033', lineHeight: 1.2, textAlign: 'center' } },
      { text: '✦  OOTD  ✦', style: { fontFamily: 'Montserrat', fontSize: 6.5, fontWeight: 500, color: '#8d6e63', letterSpacing: 4 } },
    ],
    layers: [
      { data: { type: 'text', content: 'outfit of\nthe day', style: S('Dancing Script', 76, '400', '#5c4033', { lineHeight: 1.15 }) }, transform: { x: 5, y: 30, width: 90, height: 34, zIndex: 1 } },
      { data: { type: 'text', content: '✦  O O T D  ✦', style: S('Montserrat', 18, '500', '#8d6e63', { letterSpacing: 6, lineHeight: 1 }) }, transform: { x: 5, y: 66, width: 90, height: 7, zIndex: 2 } },
    ],
  },

  // ── 37. Cinematic Title ───────────────────────────────────
  {
    id: 'tpl-37',
    name: 'Cinematic Title',
    category: 'Editorial',
    fonts: ['Cinzel', 'Lora'],
    previewStyle: { background: '#050508', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3 },
    previewContent: [
      { text: '━━━ ✦ ━━━', style: { fontFamily: 'Lora', fontSize: 7, fontWeight: 400, color: '#c9a84c' } },
      { text: 'KINGDOM\nOF\nSTONE', style: { fontFamily: 'Cinzel', fontSize: 16, fontWeight: 400, color: '#e8d5a3', lineHeight: 1.15, textAlign: 'center', letterSpacing: 4 } },
      { text: '━━━ ✦ ━━━', style: { fontFamily: 'Lora', fontSize: 7, fontWeight: 400, color: '#c9a84c' } },
    ],
    layers: [
      { data: { type: 'text', content: '━━━━  ✦  ━━━━', style: S('Lora', 18, '400', '#c9a84c', { lineHeight: 1 }) }, transform: { x: 5, y: 22, width: 90, height: 6, zIndex: 1 } },
      { data: { type: 'text', content: 'KINGDOM\nOF\nSTONE', style: S('Cinzel', 56, '400', '#e8d5a3', { lineHeight: 1.15, letterSpacing: 6 }) }, transform: { x: 5, y: 28, width: 90, height: 44, zIndex: 2 } },
      { data: { type: 'text', content: '━━━━  ✦  ━━━━', style: S('Lora', 18, '400', '#c9a84c', { lineHeight: 1 }) }, transform: { x: 5, y: 73, width: 90, height: 6, zIndex: 3 } },
    ],
  },

  // ── 38. Product Highlight ─────────────────────────────────
  {
    id: 'tpl-38',
    name: 'Product Spotlight',
    category: 'Retail',
    fonts: ['Poppins', 'Montserrat'],
    previewStyle: { background: '#f0f0ff', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 },
    previewContent: [
      { text: 'NEW ARRIVAL', style: { fontFamily: 'Montserrat', fontSize: 5.5, fontWeight: 700, color: 'var(--brand-primary)', background: 'var(--brand-100)', padding: '1.5px 5px', borderRadius: 2, letterSpacing: 2 } },
      { text: 'Pro Max\nUltra', style: { fontFamily: 'Poppins', fontSize: 22, fontWeight: 800, color: 'var(--brand-900)', lineHeight: 1.05, textAlign: 'center' } },
      { text: 'Starting at $999', style: { fontFamily: 'Poppins', fontSize: 6.5, fontWeight: 400, color: 'var(--brand-primary-hover)' } },
    ],
    layers: [
      { data: { type: 'text', content: 'NEW ARRIVAL', style: S('Montserrat', 16, '700', 'var(--brand-primary)', { letterSpacing: 3, lineHeight: 1 }) }, transform: { x: 5, y: 24, width: 90, height: 6, zIndex: 1 } },
      { data: { type: 'text', content: 'Pro Max\nUltra', style: S('Poppins', 80, '800', 'var(--brand-900)', { lineHeight: 1.0, letterSpacing: -1 }) }, transform: { x: 5, y: 30, width: 90, height: 36, zIndex: 2 } },
      { data: { type: 'text', content: 'Starting at $999', style: S('Poppins', 22, '400', 'var(--brand-primary-hover)', { lineHeight: 1 }) }, transform: { x: 5, y: 68, width: 90, height: 7, zIndex: 3 } },
    ],
  },

  // ── 39. Food Story ────────────────────────────────────────
  {
    id: 'tpl-39',
    name: 'Food Story',
    category: 'Food',
    fonts: ['Abril Fatface', 'Poppins'],
    previewStyle: { background: '#fff7ed', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 },
    previewContent: [
      { text: 'TODAY\'S', style: { fontFamily: 'Poppins', fontSize: 6.5, fontWeight: 300, color: '#9a3412', letterSpacing: 4 } },
      { text: 'Special', style: { fontFamily: 'Abril Fatface', fontSize: 26, fontWeight: 400, color: '#ea580c' } },
      { text: '🍝 Truffle Pasta', style: { fontFamily: 'Poppins', fontSize: 7, fontWeight: 600, color: '#431407' } },
      { text: 'freshly made with love', style: { fontFamily: 'Poppins', fontSize: 5.5, fontWeight: 300, color: '#9a3412', fontStyle: 'italic' } },
    ],
    layers: [
      { data: { type: 'text', content: 'TODAY\'S', style: S('Poppins', 16, '300', '#9a3412', { letterSpacing: 6, textTransform: 'uppercase', lineHeight: 1 }) }, transform: { x: 5, y: 24, width: 90, height: 6, zIndex: 1 } },
      { data: { type: 'text', content: 'Special', style: S('Abril Fatface', 88, '400', '#ea580c', { lineHeight: 1 }) }, transform: { x: 5, y: 29, width: 90, height: 22, zIndex: 2 } },
      { data: { type: 'text', content: '🍝 Truffle Pasta', style: S('Poppins', 28, '600', '#431407', { lineHeight: 1 }) }, transform: { x: 5, y: 53, width: 90, height: 9, zIndex: 3 } },
      { data: { type: 'text', content: 'freshly made with love', style: { ...S('Poppins', 18, '300', '#9a3412', { lineHeight: 1 }), fontStyle: 'italic' } }, transform: { x: 5, y: 63, width: 90, height: 6, zIndex: 4 } },
    ],
  },

  // ── 40. Countdown Launch ──────────────────────────────────
  {
    id: 'tpl-40',
    name: 'Product Launch',
    category: 'Marketing',
    fonts: ['Montserrat', 'Bebas Neue'],
    previewStyle: { background: '#111827', padding: '10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 },
    previewContent: [
      { text: 'COMING SOON', style: { fontFamily: 'Montserrat', fontSize: 6, fontWeight: 600, color: 'var(--brand-primary)', letterSpacing: 4 } },
      { text: 'SOMETHING\nBIG IS\nCOMING', style: { fontFamily: 'Bebas Neue', fontSize: 18, fontWeight: 400, color: '#fff', lineHeight: 1, letterSpacing: 3 } },
      { text: 'April 1, 2025', style: { fontFamily: 'Montserrat', fontSize: 6, fontWeight: 400, color: 'rgba(255,255,255,0.5)', letterSpacing: 2 } },
    ],
    layers: [
      { data: { type: 'text', content: '◈  COMING SOON  ◈', style: S('Montserrat', 16, '600', 'var(--brand-primary)', { letterSpacing: 4, lineHeight: 1 }) }, transform: { x: 5, y: 22, width: 90, height: 6, zIndex: 1 } },
      { data: { type: 'text', content: 'SOMETHING\nBIG IS\nCOMING', style: S('Bebas Neue', 76, '400', '#ffffff', { lineHeight: 0.95, letterSpacing: 4 }) }, transform: { x: 5, y: 28, width: 90, height: 44, zIndex: 2 } },
      { data: { type: 'text', content: 'April 2025', style: S('Montserrat', 20, '400', 'rgba(255,255,255,0.45)', { letterSpacing: 4, lineHeight: 1 }) }, transform: { x: 5, y: 74, width: 90, height: 6, zIndex: 3 } },
    ],
  },
];

export const TEMPLATE_CATEGORIES = [
  'All',
  'Marketing',
  'Editorial',
  'Retail',
  'Luxury',
  'Beauty',
  'Fashion',
  'Food',
  'Event',
  'Corporate',
  'Bold',
  'Modern',
  'Minimal',
];
